import React, { useState } from 'react';
import styled from 'styled-components';

interface ProductImageProps {
  src?: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
}

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f7fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: inherit;
`;

const PlaceholderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #cbd5e0;
  width: 100%;
  height: 100%;
  background-color: #f7fafc;
  border-radius: inherit;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 2rem;
  
  i {
    filter: drop-shadow(0 2px 4px rgba(0,0,0,0.05));
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.3s ease;
  border-radius: inherit;
`;

const ProductImage: React.FC<ProductImageProps> = ({ src, alt, className, style }) => {
  const [error, setError] = useState(false);

  const handleImageError = () => {
    setError(true);
  };

  if (!src || error) {
    return (
      <PlaceholderContainer className={className} style={style}>
        <IconWrapper>
          <i className="fas fa-hamburger" title="Hambúrguer"></i>
          <i className="fas fa-fries" title="Batata Frita" style={{ fontSize: '1.5rem' }}></i>
          <i className="fas fa-glass-whiskey" title="Copo" style={{ fontSize: '1.2rem' }}></i>
        </IconWrapper>
      </PlaceholderContainer>
    );
  }

  return (
    <ImageContainer className={className} style={style}>
      <StyledImage
        src={src}
        alt={alt}
        onError={handleImageError}
      />
    </ImageContainer>
  );
};

export default ProductImage;
